'use strict';
module.exports = (foo, bar) => require('dequal').dequal(foo, bar)
